export let messageSize_MB = "gPtmKb";
export let messageSize_KB = "CRTlKb";
export default {messageSize_MB,messageSize_KB};